// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"c73bf1bb","511":"c7ed63ca","623":"36859675","673":"b6c4c970","767":"90432485","823":"29f932a7"}[chunkId] + ".chunk.js";
};